var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('populate-form',{ref:"StoreInfoForm",attrs:{"formTitle":_vm.FocusedStore.store_name+'＿分店資訊維護',"fkey":"si01","populateOptionVar":"storeFormItems","formDataObjVar":"FocusedStore","validatePrompt":false,"parentVue":this}})}
var staticRenderFns = []

export { render, staticRenderFns }